import React, { useState, useEffect } from "react";
import { RoundCard } from "../../ui/RoundCard/RoundCard";
import { RunnerUpHeader } from "../../ui/runnerUpHeader/RunnerUpHeader";
import { HeadWithKeyValue } from "../../ui/HeadWithKeyValue";
import Button from "../../library/components/Button";
import "./index.css";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";
import {
  useGetStatesRequestQuery,
  useGetConstituencyRequestQuery,
  useGetPcByStateQuery,
} from "../../services/announceElection";
import { parseJwt } from "../utilities/utils";
import CustomModal from "../../library/components/Modal/modal";
import GenerateEpbPin from "../Officers/ReturningOfficer/GenerateEpbPin";
import { useGetForm13CQuery } from "../../services/preCountingServices";

export const ScanballotHeader = ({ children }) => {
  const [skipAc, setSkipAc] = useState(true);
  const [skipPc, setSkipPc] = useState(true);
  const [showModal, setShowModal] = useState(true);
  const [showScanForm, setShowScanForm] = useState(false);
  const { data: getStateList } = useGetStatesRequestQuery();
  const constType = parseJwt(localStorage.access_token)?.constituencyType;
  const stateCd = parseJwt(localStorage.access_token).authorizedStates?.[0];
  const { data: form13c, refetch } = useGetForm13CQuery();

  const state = getStateList?.filter((item) => {
    return item.stateCd === stateCd;
  })?.[0].stateName;

  const constACNumber = parseJwt(localStorage.access_token)?.authorizedAcs?.[0];
  const constPCNumber = parseJwt(localStorage.access_token)?.authorizedPcs?.[0];
  const [constName, setConstName] = useState("");

  const { data: getAcList } = useGetConstituencyRequestQuery(stateCd, {
    skip: skipAc,
  });
  const { data: getPcList } = useGetPcByStateQuery(stateCd, { skip: skipPc });

  let navigate = useNavigate();

  const list = [
    { key: "State :", value: state },
    {
      key: "Constituency :",
      value: `${constName.acNo} - ${constName.acName} (${constType})`,
    },
  ];

  useEffect(() => {
    if (constType === "AC") {
      let acName = getAcList?.filter((item) => {
        return item.asmblyNo === constACNumber;
      })?.[0].asmblyName;

      setConstName({ acName: acName, acNo: constACNumber });
    } else if (constType === "PC") {
      let pcName = getPcList?.filter((item) => {
        return item.prlmntNo == constPCNumber;
      })?.[0].parliamentName;
      setConstName({ acName: pcName, acNo: constACNumber });
    } else {
    }
  }, [getAcList, getPcList]);

  useEffect(() => {
    if (constType === "AC") {
      setSkipAc(false);
    } else if (constType === "PC") {
      setSkipPc(false);
    } else {
      //error
    }
  }, []);

  // const onScanBallot = async () => {
  //   navigate(-1);
  // };

  const onClose = () => {
    setShowModal(false);
  };

  const transmitEpbPin = () => {
    setShowScanForm(true);
  };

  return (
    <div className="pre-count my-4 container">
      <CustomModal
        className="custom_modal confirm-modal"
        show={showModal}
        onClose={onClose}
        size="55%"
        closeIcon={true}
        // modalTitle={props.localLang?.CONFIRMATION_POPUP?.TITLE}
        children={
          <GenerateEpbPin
            module={"Precounting"}
            onConfirm={transmitEpbPin}
            message={"start scanning for e-Paper Vote."}
            showConfirmationBox={false}
            number={form13c?.payload?.mobile}
            onShowModal={() => setShowModal(false)}
          />
        }
      />
      <div className="">
        <RunnerUpHeader
          label={
            <>
              <p>
                {"Scan Ballot Paper"}
                <span style={{ marginLeft: "186px", color: "white" }}>
                  State: {state}
                  <span
                    style={{ marginLeft: "15px", color: "white" }}
                  ></span>{" "}
                  Constituency: {constName.acNo} - {constName.acName} (
                  {constType})
                </span>
              </p>
            </>
          }
        />
        <div className=" row head_key-vlaue">
          <div className="col-md-9">
            {" "}
            {/* <HeadWithKeyValue list={list} /> */}
          </div>
          <div className="col-md-3">
            {/* <Button
              value="scan forms"
              btnClass="button-class"
              onClick={onScanBallot}
            /> */}
          </div>
          {showScanForm && children}
        </div>
      </div>
    </div>
  );
};
